import { usePermissionsRepository } from '@Hooks/useRepository';
import type { ApiPermission } from '@Model';
import { PermissionsRepository } from '@Repositories/Permissions';
import { isOk } from '@synqo/frontend-component-library';
import { useQuery } from '@tanstack/react-query';

export interface PermissionGroup {
    id: string;
    children: ApiPermission[];
}

export const useLoadAllPermissions = () => {
    const permissions = usePermissionsRepository(PermissionsRepository);

    return useQuery({
        queryFn: async (): Promise<ApiPermission[]> => {
            const result = await permissions.getAll();
            if (isOk(result)) {
                return result.data.items;
            } else {
                return [];
            }
        },
        queryKey: ['permissions', 'all'],
        initialData: [],
    });
};
